export const TYPES = [
  {
    id: 'pg-recording',
    value: 'pg-recording',
    label: 'PG recording',
  },
  {
    id: 'psg-recording',
    value: 'psg-recording',
    label: 'PSG recording',
  },
  {
    id: 'consent-form',
    value: 'consent-form',
    label: 'Consent form',
  },
  {
    id: 'sleep-qq',
    value: 'sleep-quality-questionnaire',
    label: 'Sleep Quality Questionnaire',
  },
  {
    id: 'pg-report',
    value: 'pg-report',
    label: 'PG report',
  },
  {
    id: 'psg-report',
    value: 'psg-report',
    label: 'PSG report',
  },
  {
    id: 'fds',
    value: 'fds',
    label: 'Feuille de soins',
  },
  {
    id: 'payment-receipt',
    value: 'payment-receipt',
    label: 'Payment receipt',
  },
  {
    id: 'mutual-insurance-card',
    value: 'mutual-insurance-card',
    label: 'Mutual insurance card',
  },
  {
    id: 'dap',
    value: 'dap',
    label: 'DAP',
  },
  {
    id: 'prescription',
    value: 'prescription',
    label: 'Prescription',
  },
  {
    id: 'referral-letter',
    value: 'referral-letter',
    label: 'Referral letter',
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other document',
  },
];

export const DOCTOR_TYPES = [
  {
    id: 'pg-report',
    value: 'pg-report',
    label: 'PG report',
  },
  {
    id: 'psg-report',
    value: 'psg-report',
    label: 'PSG report',
  },
  {
    id: 'fds',
    value: 'fds',
    label: 'Feuille de soins',
  },
  {
    id: 'payment-receipt',
    value: 'payment-receipt',
    label: 'Payment receipt',
  },
  {
    id: 'mutual-insurance-card',
    value: 'mutual-insurance-card',
    label: 'Mutual insurance card',
  },
  {
    id: 'dap',
    value: 'dap',
    label: 'DAP',
  },
  {
    id: 'prescription',
    value: 'prescription',
    label: 'Prescription',
  },
  {
    id: 'referral-letter',
    value: 'referral-letter',
    label: 'Referral letter',
  },
  {
    id: 'other',
    value: 'other',
    label: 'Other document',
  },
];

export const TECHNICIAN_TYPES = [
  {
    id: 'pg-recording',
    value: 'pg-recording',
    label: 'PG recording',
  },
  {
    id: 'psg-recording',
    value: 'psg-recording',
    label: 'PSG recording',
  },
  {
    id: 'consent-form',
    value: 'consent-form',
    label: 'Consent form',
  },
  {
    id: 'sleep-qq',
    value: 'sleep-quality-questionnaire',
    label: 'Sleep Quality Questionnaire',
  },
];

export const SIGNATURE_STATUS = [
  {
    id: 'signed',
    value: 'signed',
    label: 'Signed',
  },
  {
    id: 'not-signed',
    value: 'not-signed',
    label: 'Not signed',
  },
];

export const ALD_OPTIONS = [
  { id: 'oui', title: 'Oui' },
  { id: 'non', title: 'Non' },
];

export const MALADIE_OPTIONS = [
  { id: 'oui', title: 'Oui' },
  { id: 'non', title: 'Non' },
];

export const PRESCRIPTION_OPTIONS = [
  { id: 'ppc', title: 'Pression positive continue (PPC)' },
  {
    id: 'oam',
    title: `Orthèse d'avancée mandibulaire (OAM)`,
  },
];

export const PRESCRIPTION_TYPE_OPTIONS = [
  { id: 'initial', title: 'Prescription initiale' },
  {
    id: 'first-renewal',
    title: '1er renouvellement à 4 mois',
  },
  { id: 'annual-renewal', title: 'Renouvellement annuel' },
];

export const CPAP_DEVICE_TYPE_OPTIONS = [
  { id: 'autopiloted', title: 'Autopilotée' },
  {
    id: 'fixed-presure',
    title: 'A pression fixe',
  },
  { id: 'double-presure', title: 'A double niveau de pression' },
];

export const EXAMINATION_OPTIONS = [
  { id: 'polygraphy', title: 'Polygraphie' },
  {
    id: 'polysomnography',
    title: 'Polysomnographie',
  },
];
